<template>
  <div class="head">
    <div class="head-logo" @click="goHome">
      <div class="head-logo-img"></div>
      <div>MIS营销情报系统</div>
    </div>
    <div class="head-menu">
      <ul v-if="MenuStatus">
        <template v-for="(item, index) in arr">
          <router-link class="tab_item" :to="item.path" :key="index" tag="li">
            <span class="tab_span"
              ><i :class="item.icon"></i>{{ item.title }}</span
            >
          </router-link>
        </template>
      </ul>
    </div>

    <div class="head-user">
      <!-- <div style="margin-right: 40px" v-if="MenuStatus">
        <el-input
          placeholder="请输入关键字搜索"
          prefix-icon="el-icon-search"
          v-model="allKey"
          style="width: 200px"
          @keyup.enter.native="handleEnterSearch"
        >
        </el-input>
      </div> -->
      <router-link to="/version">
        <div class="version">版本号 {{ version }}</div>
      </router-link>
      <el-divider direction="vertical"></el-divider>

      <el-dropdown @command="fnUserCommand" size="large" trigger="click">
        <div class="user-name">
          <i class="avatar"></i>欢迎您：{{ userName }}
          <i class="el-icon-arrow-down"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            icon="el-icon-set-up"
            command="1"
            v-if="codes.indexOf('MIS2.0-background-manage') >= 0"
          >
            后台管理
          </el-dropdown-item>
          <el-dropdown-item icon="el-icon-notebook-2" command="2">
            名词解释
          </el-dropdown-item>
          <el-dropdown-item icon="el-icon-switch-button" command="0">
            退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { versionT } from "@/pages/views/version/version.js";

export default {
  computed: {
    ...mapGetters(["userName", "user", "codes", "isVisable"])
  },
  props: {
    MenuStatus: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      version: "",
      arr: [
        // { title: "任务管理", path: "/task" },
        // { title: "需求管理", path: "/request" },
        // { title: "首页", path: "/" },
        { title: "首页", icon: "el-icon-house", path: "/home" },
        {
          title: "项目生命周期",
          icon: "el-icon-data-line",
          path: "/lifecycle"
        },
        { title: "销售管理", icon: "el-icon-coin", path: "/sales" },
        { title: "市场分析", icon: "el-icon-pie-chart", path: "/market" }
      ],
      allKey: ""
    };
  },

  activated() {},
  watch: {},
  created() {},
  mounted() {
    this.version = versionT;

    // 通过事件总线监听消息
    // eventBus.$on("MenuStatus", (val) => {
    //   this.MenuStatus = val;
    // });
  },
  methods: {
    // 退出登录
    logout() {
      this.$confirm("确认退出登录？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store.dispatch("LogOut").then(() => {
          location.reload();
        });
      });
    },

    goHome() {
      this.$router.push("/");
    },
    fnUserCommand(command) {
      if (command === 0) {
        this.logout();
      } else if (command === 2) {
        this.$router.push("/noun");
      } else {
        window.location.href = "/manage/";
      }
    },

    handleEnterSearch() {
      const routeUrl = this.$router.resolve({
        path: "/searchResult",
        query: {
          allKey: this.allKey
        }
      });
      window.open(routeUrl.href, "_blank");
      this.allKey = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.head {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--color-border);
  padding: 0 30px;
  position: relative;
  background: #fff;
}
.head-logo {
  width: 240px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 22px;
  font-weight: 500;
  margin-right: 40px;
  cursor: pointer;
  .head-logo-img {
    width: 32px;
    height: 32px;
    background: url(~@/assets/logo.png) no-repeat;
    background-size: 100%;
    border: 1px solid #ededed;
    border-radius: 2px;
    margin-right: 10px;
    @media only screen and (-webkit-min-device-pixel-ratio: 2) {
      background: url(~@/assets/logo@2x.png) no-repeat;
      background-size: 100%;
    }
  }
}
.head-menu {
  flex: 1;
  ul {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .tab_item {
      list-style: none;
      padding: 0 20px;
      font-size: 14px;
      font-weight: 500;
      color: var(--text-2);
      display: block;
      position: relative;
      transition: all 0.3s ease-in-out;
      cursor: pointer;
      .tab_span {
        display: block;
        i {
          margin-right: 4px;
        }
      }
      // &.router-link-active {
      // .tab_span {
      //   color: var(--brand);
      // }
      // }
      &.router-link-exact-active {
        .tab_span {
          color: var(--brand);
        }
        // &::after {
        //   content: " ";
        //   position: absolute;
        //   bottom: -20px;
        //   left: 0;
        //   display: block;
        //   width: 100%;
        //   height: 2px;
        //   background: var(--brand);
        // }
      }

      &:hover {
        color: var(--text-link);
      }
    }
  }
}

::v-deep .active {
  color: var(--brand) !important;
}

.head-user {
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .version {
    margin-right: 20px;
    font-size: 12px;
    color: var(--text-tips);
    transition: color 0.2s ease-in-out;

    &:hover {
      color: var(--text-1);
    }
  }
}
.user-name {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: var(--text-2);
  margin-left: 15px;
  cursor: pointer;
  transition: color 0.2s ease-in-out;
  &:hover {
    color: var(--text-1);
  }

  .avatar {
    width: 16px;
    height: 16px;
    border-radius: 16px;
    display: block;
    background: url("~@/assets/default_avatar.png") no-repeat;
    background-size: 100%;
    margin-right: 5px;
  }
}
.el-icon-arrow-down {
  margin-left: 5px;
}
</style>
